import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import color from 'color';
import { useMemo } from 'react';
import { Rect } from './rect';
const DEFAULT_HIGHLIGHT_PADDING_PX = 5;
const DEFAULT_HIGHLIGHT_RATIO = 0.4;
export const RectWithHighlight = ({ fillColor, radius, x, y, w, h, lineWidth, lineColor, highlightRatio = DEFAULT_HIGHLIGHT_RATIO, highlightPaddingPx = DEFAULT_HIGHLIGHT_PADDING_PX }) => {
    const highlightX = x + highlightPaddingPx;
    const highlightW = w - 2 * highlightPaddingPx;
    const highlightY = y + highlightPaddingPx;
    const highlightH = highlightRatio * h - highlightPaddingPx;
    const highlightColor = useMemo(() => color(fillColor).lighten(0.1).rgbNumber(), [fillColor]);
    return (_jsxs(_Fragment, { children: [_jsx(Rect, { fillColor: fillColor, x: x, y: y, w: w, h: h, radius: radius, lineWidth: lineWidth, lineColor: lineColor }), _jsx(Rect, { fillColor: highlightColor, x: highlightX, y: highlightY, w: highlightW, h: highlightH, radius: radius })] }));
};
